module.exports = __webpack_public_path__ + "img/badge-none.0f672896.svg";